module.exports = __webpack_public_path__ + "img/company37.0bb4f8fb.png";